"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var CategoryValidationService = /** @class */ (function () {
    function CategoryValidationService() {
        this.schemaForGetCategories = joi_1.default.object().keys({}).unknown(true);
    }
    CategoryValidationService.prototype.getCategoriesData = function (data) {
        var error = this.schemaForGetCategories.validate(data).error;
        // debug
        console.debug('Validating get categories data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return CategoryValidationService;
}());
exports.CategoryValidationService = CategoryValidationService;
//# sourceMappingURL=CategoryValidationService.js.map